import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
} from "@mui/material";
import CustomButton from "../../../ui/button/Button";
import SelectAutoComplete from "../../../ui/selectAutoComplete/SelectAutoComplete";
import { useState, useEffect } from "react";
import {
  getTiposEquipo,
  getTiposTensionEquipo,
  getVoltajesEquiposMedicionPorTipoTension,
  calcularEquipoMedicion,
  descargarPDFEquiposMedicion,
} from "../../../components/functions/Soporte";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import DescargarG2 from "../../../assets/img/svg/users/descargar.svg";

const CalcularEquipoMedicion = ({ open, onClose, API_URL }) => {
  const [tiposTension, setTiposTension] = useState([]);
  const [voltajes, setVoltajes] = useState([]);
  const [tiposEquipos, setTiposEquipos] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [potencia, setPotencia] = useState("");
  const [nivelTension, setNivelTension] = useState(null);
  const [nivelVoltaje, setNivelVoltaje] = useState(null);
  const [tipoAcometida, setTipoAcometida] = useState(null);

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const voltajesRes = await getVoltajesEquiposMedicionPorTipoTension(
        API_URL,
        nivelTension.name
      );

      const v = voltajesRes.map((voltaje) => ({
        label: voltaje.toString(),
        value: voltaje.toString(),
      }));

      setNivelVoltaje(null);

      setVoltajes(v);
    };

    if (nivelTension) {
      fetchData();
    }
  }, [nivelTension]);

  useEffect(() => {
    const fetchData = async () => {
      const [tiposEquiposRes, getTiposTensionEquipoRes] = await Promise.all([
        getTiposEquipo(API_URL),
        getTiposTensionEquipo(API_URL),
      ]);

      tiposEquiposRes.map((tipo) => {
        switch (tipo.lenguaje) {
          case "AERIAL":
            tipo.newName = "Aéreo";
            break;
          case "UNDERGOUND_PEDESTAL":
            tipo.newName = "Subterráneo (Pedestal)";
            break;
          case "NOT_APPLICABLE":
            tipo.newName = "No aplica";
            break;
          default:
            tipo.newName = tipo.lenguaje;
            break;
        }
      });

      setTiposEquipos(tiposEquiposRes);
      setTiposTension(getTiposTensionEquipoRes);
    };

    if (open) {
      fetchData();
    }
  }, [open]);

  const handleClose = () => {
    onClose();
    setPotencia("");
    setNivelTension(null);
    setNivelVoltaje(null);
    setTipoAcometida(null);
    setTiposEquipos([]);
    setVoltajes([]);
    setTiposTension([]);
    setTableData([]);
  };

  const handleConfirm = async () => {
    if (!potencia || !nivelTension || !nivelVoltaje) {
      setShowSnackbar(true);
      setSnackbarMessage("Por favor, complete todos los campos obligatorios.");
      return;
    }
    const payload = {
      potencia: Number(potencia),
      tipoTensionEquipo: nivelTension,
      voltaje: Number(nivelVoltaje.label),
      tipoEquipo: tipoAcometida,
    };

    try {
      const res = await calcularEquipoMedicion(API_URL, payload);
      setTableData(res);
    } catch (error) {
      setShowSnackbar(true);
      setSnackbarMessage("Error al calcular el equipo de medición.");
    }
  };

  const descargarPDF = async (equipoId) => {
    try {
      const blob = await descargarPDFEquiposMedicion(API_URL, tableData);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Seleccion_de_Equipo_de_medicion.pdf`;
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      setShowSnackbar(true);
      setSnackbarMessage("Error al descargar el PDF del equipo de medición.");
    }
  };

  const columns = [
    {
      header: "Nivel de Tensión en Centro de Carga",
      size: 40,
      accessorFn: (row) => row.tipoTensionEquipo.descripcion,
    },
    {
      header: "Voltaje",
      size: 20,
      accessorFn: (row) => `${row.voltaje} V`,
    },
    {
      header: "Corriente     Mínima",
      size: 25,
      accessorFn: (row) => `${row.corrienteMin} A`,
    },
    {
      header: "Corriente     Máxima",
      size: 25,
      accessorFn: (row) => `${row.corrienteMax} A`,
    },
    {
      header: "REL TC",
      size: 20,
      accessorKey: "relacionTransformacionCorriente",
    },
    {
      header: "Equipo",
      size: 100,
      accessorKey: "equipo",
      grow: true,
    },
    {
      header: "Tipo de    Acometida",
      size: 25,
      accessorFn: (row) => {
        const value = row.tipoEquipo.lenguaje;
        switch (value) {
          case "AERIAL":
            return "Aéreo";
          case "UNDERGOUND_PEDESTAL":
            return "Subterráneo (Pedestal)";
          case "NOT_APPLICABLE":
            return "No aplica";
          default:
            return value;
        }
      },
    },
    {
      id: "descargarPdf",
      header: "Descargar          PDF",
      size: 20,
      Cell: ({ row }) => (
        <div
          onClick={() => descargarPDF()}
          style={{
            cursor: "pointer",
            color: "#1a73e8",
            textDecoration: "underline",
          }}
        >
          <img style={{ marginRight: 0 }} src={DescargarG2} alt="" />
        </div>
      ),
    },
  ];

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: tableData?.equiposSeleccionados || [],
    enableSorting: true,
    enableFilters: false,
    enableTopToolbar: false,
    enableColumnActions: false,
    getRowId: (originalRow) => originalRow.id,
    positionToolbarAlertBanner: "none",
    localization: MRT_Localization_ES,
    layoutMode: "grid",
    defaultColumn: {
      minSize: 20,
      size: 80,
    },
  });

  return (
    <Dialog fullWidth maxWidth="xl" open={open} onClose={handleClose}>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <DialogTitle>Calcular equipo de medición</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "16px",
          }}
        >
          <div>
            <label className="form-label">
              Potencia en punto de carga (KW) *
            </label>
            <input
              className="form-input"
              placeholder="Potencia..."
              value={potencia || ""}
              onChange={(e) => {
                setPotencia(e.target.value);
              }}
              style={{ color: "black" }}
              type="number"
            />
          </div>
          <div>
            <label className="form-label">
              Nivel de Tensión en Centro de Carga *
            </label>
            <SelectAutoComplete
              label=""
              fieldC="descripcion"
              options={tiposTension}
              value={nivelTension}
              onChange={(e, value) => {
                setNivelTension(value);
              }}
              placeholder="Seleccionar..."
              size="small"
              width={"100%"}
              listHeight="200px"
            />
          </div>
          <div>
            <label className="form-label">Nivel de Voltaje (V) *</label>
            <SelectAutoComplete
              label=""
              options={voltajes}
              value={nivelVoltaje}
              onChange={(e, value) => setNivelVoltaje(value)}
              placeholder="Seleccionar..."
              size="small"
              width={"100%"}
              listHeight="200px"
            />
          </div>
          <div>
            <label className="form-label">Tipo de acometida</label>
            <SelectAutoComplete
              label=""
              fieldC="newName"
              options={tiposEquipos}
              value={tipoAcometida}
              onChange={(e, value) => setTipoAcometida(value)}
              placeholder="Seleccionar..."
              size="small"
              width={"100%"}
              listHeight="200px"
            />
          </div>
        </div>
        <div
          style={{
            margin: "10px 0",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <h2>Corriente: {tableData?.corriente || 0} A</h2>
        </div>
        <div style={{ width: "100%", margin: "10px 0 " }}>
          <MaterialReactTable table={table} />
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#a2a2a2"}
          color={"#FFFFFF"}
          text="Limpiar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={() => {
            setPotencia("");
            setNivelTension(null);
            setNivelVoltaje(null);
            setTipoAcometida(null);
            setVoltajes([]);
            setTableData([]);
          }}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Calcular"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CalcularEquipoMedicion;
